import { QueryClient } from '@tanstack/react-query';

const THIRTY_MINUTES_IN_MS = 1000 * 60 * 30;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: THIRTY_MINUTES_IN_MS,
    },
  },
});
